import { injectEmspBoLocationApi } from '@delmonicos/shared-sdk/libs/cpms/src/clients/redux/emsp-bo-location.service';

import { baseApi } from '@service/base-api.service';

export const emspBoLocationApi = injectEmspBoLocationApi(baseApi);

export const {
  useEmspBoGetLocationsQuery,
  useEmspBoGetLocationQuery,
  useEmspBoGetConnectorQuery,
  useEmspBoGetEvseQuery,
  useEmspBoPullLocationsMutation,
} = emspBoLocationApi;
